import { useEffect } from "react";

/**
 * Ensures the global theme is active on the document.
 * The Teamlio theme is a single unified system (see src/styles/global-theme.css).
 * All pages, modals, and portaled components inherit it automatically because
 * the `gt-themed` class is applied to <body>.
 */
export function useTheme() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (!document.body.classList.contains("gt-themed")) {
      document.body.classList.add("gt-themed");
    }
  }, []);
}
